import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import React from "react"
import Trans from '../../../../../components/Trans'

type IdentificationProps = {
  vehicle: Vehicle
}

class Identification extends React.Component<IdentificationProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fab', 'slack']}/> <Trans>Identifikation</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-full truncate flex flex-col'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Fahrgestellnummer</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.Vin || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw">HSN</span>
            <span className="font-semibold text-gray-800">{vehicle.Hsn || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw">TSN</span>
            <span className="font-semibold text-gray-800">{vehicle.Tsn || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Int. Nr.</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.LocalCode || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Platz Nr.</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.LocalKey || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Standort</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.Location || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Nummernschild</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.LicensePlate || '-'}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default Identification
